import React from "react";
import { Link } from "react-router-dom";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Alert, Button, Form, FormField, PasswordInput, TextInput } from "./ui";
import type { FlashMessage } from "../types/state";

interface FormErrorItem {
  code: string;
  message: string;
}

interface LoginFormProps extends WithTranslation {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  formError?: FormErrorItem[];
  message?: FlashMessage | null;
  isAuthenticating?: boolean;
}

function LoginForm({
  t,
  onChange,
  onSubmit,
  formError,
  message,
  isAuthenticating = false,
}: LoginFormProps) {
  const emailId = "LoginForm-email";
  const passwordId = "LoginForm-password";
  const formErrorId = "LoginForm-errors";
  const messageId = "LoginForm-message";

  return (
    <Form action="/" onSubmit={onSubmit} className="Form LoginForm" noValidate>
      {formError && formError.length > 0 ? (
        <Alert variant="error" className="Form-message error" id={formErrorId}>
          {formError.map((error) => (
            <span key={error.code} className="Form-messageLine">
              {error.message}
            </span>
          ))}
        </Alert>
      ) : null}
      {message ? (
        <Alert variant={message.type} className={"Form-message " + message.type} id={messageId}>
          {message.content}
        </Alert>
      ) : null}
      <FormField
        className="Form-line"
        label={t("login.label_mail_customer")}
        htmlFor={emailId}
        hint={t("login.info_mail_customer")}
      >
        <TextInput
          className="Form-input LoginForm-email"
          name="email"
          id={emailId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null, message ? messageId : null]
            .filter(Boolean)
            .join(" ")}
        />
      </FormField>
      <FormField
        className="Form-line"
        label={t("login.label_pwd_customer")}
        htmlFor={passwordId}
        hint={
          <Link to={BASE_PATH + "/reset_password"} className="Form-link">
            {t("login.info_pwd_customer")}
          </Link>
        }
      >
        <PasswordInput
          className="Form-input LoginForm-password"
          name="password"
          id={passwordId}
          onChange={onChange}
          aria-describedby={[formError?.length ? formErrorId : null, message ? messageId : null]
            .filter(Boolean)
            .join(" ")}
        />
      </FormField>
      <div className="Form-line isActionLine">
        <Button
          type="submit"
          size="lg"
          className="Button LoginForm-submit isLarge"
          loading={isAuthenticating}
        >
          {t("login.label_connect")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(LoginForm);
